var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314 411.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.09,22.6a525.07,525.07,0,0,1,64.09,3.6q29.07,3.61,63.57,16.47T282.66,76.9Q306.08,98.27,322,137.13t16,91.37q0,50.46-15.7,88.8t-39.38,60q-23.68,21.63-57.14,35T162,430a454.6,454.6,0,0,1-64.86,4.38H29.66c-3.78,0-5.66-1.55-5.66-4.63V268.13h78.75v90.6a272.5,272.5,0,0,0,35.78-.26q16.72-1.28,40.15-8.24t39.89-20.08Q235,317,246.89,290.78t11.84-62.29q0-70-42.47-102.18T102.75,97.75v91.11H24V27.23c0-3.09,1.88-4.63,5.66-4.63Z",
    transform: "translate(-24 -22.6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDLogoWhite);
export default __webpack_public_path__ + "static/media/d-logo-white.adb35386a0d40c1b1d241f0c23bf8376.svg";
export { ForwardRef as ReactComponent };